import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{body-class "password-reset-page"}}
{{hide-application-sidebar}}
{{hide-application-header-buttons "search" "login" "signup"}}
<div class="container password-reset clearfix">
  <div class="pull-left col-image">
    <img src={{this.lockImageUrl}} class="password-reset-img" alt="" />
  </div>

  <div class="pull-left col-form">
    {{#if this.successMessage}}
      <p>{{this.successMessage}}</p>

      {{#if this.requiresApproval}}
        <p>{{i18n "login.not_approved"}}</p>
      {{else}}
        {{#unless this.redirected}}
          <a
            class="btn"
            href={{this.redirectHref}}
            {{on "click" this.done}}
          >{{this.continueButtonText}}</a>
        {{/unless}}
      {{/if}}
    {{else}}
      <form class="change-password-form">
        {{#if this.securityKeyOrSecondFactorRequired}}
          <h2>{{i18n "user.change_password.title"}}</h2>
          <p>
            {{i18n "user.change_password.verify_identity"}}
          </p>
          {{#if this.errorMessage}}
            <div class="alert alert-error">{{this.errorMessage}}</div>
            <br />
          {{/if}}

          {{#if this.displaySecurityKeyForm}}
            <SecurityKeyForm
              @setSecondFactorMethod={{fn
                (mut this.selectedSecondFactorMethod)
              }}
              @backupEnabled={{this.backupEnabled}}
              @totpEnabled={{this.secondFactorRequired}}
              @otherMethodAllowed={{this.otherMethodAllowed}}
              @action={{this.authenticateSecurityKey}}
            />
          {{else}}
            <SecondFactorForm
              @secondFactorMethod={{this.selectedSecondFactorMethod}}
              @secondFactorToken={{this.secondFactorToken}}
              @backupEnabled={{this.backupEnabled}}
              @totpEnabled={{this.secondFactorRequired}}
              @isLogin={{false}}
            >
              <SecondFactorInput
                {{on
                  "input"
                  (with-event-value (fn (mut this.secondFactorToken)))
                }}
                @secondFactorMethod={{this.selectedSecondFactorMethod}}
                value={{this.secondFactorToken}}
                id="second-factor"
              />
            </SecondFactorForm>
          {{/if}}

          {{#unless this.displaySecurityKeyForm}}
            <DButton
              @action={{action "submit"}}
              @label="submit"
              type="submit"
              class="btn-primary"
            />
          {{/unless}}
        {{else}}
          <h2>{{i18n "user.change_password.choose"}}</h2>
          {{#if this.errorMessage}}
            <div class="alert alert-error">{{this.errorMessage}}</div>
            <br />
          {{/if}}

          <div class="input">
            <PasswordField
              @value={{this.accountPassword}}
              @capsLockOn={{this.capsLockOn}}
              type={{if this.maskPassword "password" "text"}}
              autofocus="autofocus"
              autocomplete="new-password"
              id="new-account-password"
            />
            <TogglePasswordMask
              @maskPassword={{this.maskPassword}}
              @togglePasswordMask={{this.togglePasswordMask}}
            />

            <div class="caps-lock-warning {{unless this.capsLockOn 'hidden'}}">
              {{d-icon "exclamation-triangle"}}
              {{i18n "login.caps_lock_warning"}}
            </div>
          </div>

          <InputTip @validation={{this.passwordValidation}} />

          <DButton
            @action={{action "submit"}}
            @label="user.change_password.set_password"
            type="submit"
            class="btn-primary"
          />
        {{/if}}
      </form>
    {{/if}}
  </div>
</div>
*/
{
  "id": "rN7CItxN",
  "block": "[[[1,[28,[35,0],[\"password-reset-page\"],null]],[1,\"\\n\"],[1,[34,1]],[1,\"\\n\"],[1,[28,[35,2],[\"search\",\"login\",\"signup\"],null]],[1,\"\\n\"],[10,0],[14,0,\"container password-reset clearfix\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"pull-left col-image\"],[12],[1,\"\\n    \"],[10,\"img\"],[15,\"src\",[30,0,[\"lockImageUrl\"]]],[14,0,\"password-reset-img\"],[14,\"alt\",\"\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"pull-left col-form\"],[12],[1,\"\\n\"],[41,[30,0,[\"successMessage\"]],[[[1,\"      \"],[10,2],[12],[1,[30,0,[\"successMessage\"]]],[13],[1,\"\\n\\n\"],[41,[30,0,[\"requiresApproval\"]],[[[1,\"        \"],[10,2],[12],[1,[28,[35,4],[\"login.not_approved\"],null]],[13],[1,\"\\n\"]],[]],[[[41,[51,[30,0,[\"redirected\"]]],[[[1,\"          \"],[11,3],[24,0,\"btn\"],[16,6,[30,0,[\"redirectHref\"]]],[4,[38,6],[\"click\",[30,0,[\"done\"]]],null],[12],[1,[30,0,[\"continueButtonText\"]]],[13],[1,\"\\n\"]],[]],null]],[]]]],[]],[[[1,\"      \"],[10,\"form\"],[14,0,\"change-password-form\"],[12],[1,\"\\n\"],[41,[30,0,[\"securityKeyOrSecondFactorRequired\"]],[[[1,\"          \"],[10,\"h2\"],[12],[1,[28,[35,4],[\"user.change_password.title\"],null]],[13],[1,\"\\n          \"],[10,2],[12],[1,\"\\n            \"],[1,[28,[35,4],[\"user.change_password.verify_identity\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"],[41,[30,0,[\"errorMessage\"]],[[[1,\"            \"],[10,0],[14,0,\"alert alert-error\"],[12],[1,[30,0,[\"errorMessage\"]]],[13],[1,\"\\n            \"],[10,\"br\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"displaySecurityKeyForm\"]],[[[1,\"            \"],[8,[39,7],null,[[\"@setSecondFactorMethod\",\"@backupEnabled\",\"@totpEnabled\",\"@otherMethodAllowed\",\"@action\"],[[28,[37,8],[[28,[37,9],[[30,0,[\"selectedSecondFactorMethod\"]]],null]],null],[30,0,[\"backupEnabled\"]],[30,0,[\"secondFactorRequired\"]],[30,0,[\"otherMethodAllowed\"]],[30,0,[\"authenticateSecurityKey\"]]]],null],[1,\"\\n\"]],[]],[[[1,\"            \"],[8,[39,10],null,[[\"@secondFactorMethod\",\"@secondFactorToken\",\"@backupEnabled\",\"@totpEnabled\",\"@isLogin\"],[[30,0,[\"selectedSecondFactorMethod\"]],[30,0,[\"secondFactorToken\"]],[30,0,[\"backupEnabled\"]],[30,0,[\"secondFactorRequired\"]],false]],[[\"default\"],[[[[1,\"\\n              \"],[8,[39,11],[[16,2,[30,0,[\"secondFactorToken\"]]],[24,1,\"second-factor\"],[4,[38,6],[\"input\",[28,[37,12],[[28,[37,8],[[28,[37,9],[[30,0,[\"secondFactorToken\"]]],null]],null]],null]],null]],[[\"@secondFactorMethod\"],[[30,0,[\"selectedSecondFactorMethod\"]]]],null],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"\\n\"],[41,[51,[30,0,[\"displaySecurityKeyForm\"]]],[[[1,\"            \"],[8,[39,13],[[24,0,\"btn-primary\"],[24,4,\"submit\"]],[[\"@action\",\"@label\"],[[28,[37,14],[[30,0],\"submit\"],null],\"submit\"]],null],[1,\"\\n\"]],[]],null]],[]],[[[1,\"          \"],[10,\"h2\"],[12],[1,[28,[35,4],[\"user.change_password.choose\"],null]],[13],[1,\"\\n\"],[41,[30,0,[\"errorMessage\"]],[[[1,\"            \"],[10,0],[14,0,\"alert alert-error\"],[12],[1,[30,0,[\"errorMessage\"]]],[13],[1,\"\\n            \"],[10,\"br\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"\\n          \"],[10,0],[14,0,\"input\"],[12],[1,\"\\n            \"],[8,[39,15],[[24,\"autofocus\",\"autofocus\"],[24,\"autocomplete\",\"new-password\"],[24,1,\"new-account-password\"],[16,4,[52,[30,0,[\"maskPassword\"]],\"password\",\"text\"]]],[[\"@value\",\"@capsLockOn\"],[[30,0,[\"accountPassword\"]],[30,0,[\"capsLockOn\"]]]],null],[1,\"\\n            \"],[8,[39,16],null,[[\"@maskPassword\",\"@togglePasswordMask\"],[[30,0,[\"maskPassword\"]],[30,0,[\"togglePasswordMask\"]]]],null],[1,\"\\n\\n            \"],[10,0],[15,0,[29,[\"caps-lock-warning \",[52,[51,[30,0,[\"capsLockOn\"]]],\"hidden\"]]]],[12],[1,\"\\n              \"],[1,[28,[35,17],[\"exclamation-triangle\"],null]],[1,\"\\n              \"],[1,[28,[35,4],[\"login.caps_lock_warning\"],null]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[8,[39,18],null,[[\"@validation\"],[[30,0,[\"passwordValidation\"]]]],null],[1,\"\\n\\n          \"],[8,[39,13],[[24,0,\"btn-primary\"],[24,4,\"submit\"]],[[\"@action\",\"@label\"],[[28,[37,14],[[30,0],\"submit\"],null],\"user.change_password.set_password\"]],null],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[],false,[\"body-class\",\"hide-application-sidebar\",\"hide-application-header-buttons\",\"if\",\"i18n\",\"unless\",\"on\",\"security-key-form\",\"fn\",\"mut\",\"second-factor-form\",\"second-factor-input\",\"with-event-value\",\"d-button\",\"action\",\"password-field\",\"toggle-password-mask\",\"d-icon\",\"input-tip\"]]",
  "moduleName": "discourse/templates/password-reset.hbs",
  "isStrictMode": false
});